module.exports = require("live/components/ui/Loading");